const Webhooks = () => import("@/modules/webhooks/pages/Webhooks.vue");
const ViewWebhook = () => import("@/modules/webhooks/pages/ViewWebhook.vue");
const CreateWebhook = () =>
  import("@/modules/webhooks/pages/CreateWebhook.vue");
const EditWebhook = () => import("@/modules/webhooks/pages/EditWebhook.vue");
const DeleteWebhook = () =>
  import("@/modules/webhooks/pages/DeleteWebhook.vue");

export default [
  {
    path: "/settings/webhooks",
    name: "webhooks",
    component: Webhooks,
    children: [
      {
        path: "/settings/webhooks/create",
        name: "createWebhook",
        component: CreateWebhook,
        meta: {
          authRequired: true,
        },
      },
    ],
    meta: {
      authRequired: true,
      allowDevelopers: true,
    },
  },
  {
    path: "/settings/webhooks/:webhookId",
    name: "viewWebhook",
    component: ViewWebhook,
    children: [
      {
        path: "/settings/webhooks/edit/:webhookId",
        name: "editWebhook",
        component: EditWebhook,
        meta: {
          authRequired: true,
        },
      },
      {
        path: "/settings/webhooks/delete/:webhookId",
        name: "deleteWebhook",
        component: DeleteWebhook,
        meta: {
          authRequired: true,
        },
      },
    ],
    meta: {
      authRequired: true,
      allowDevelopers: true,
    },
  }
];
